export default __webpack_public_path__ + "static/media/cp_geo_ru.dc0e97da.svg";